import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Box, Grid, IconButton, MenuItem, Tooltip, Typography } from '@mui/material';
import React, { useCallback, useEffect, useState } from 'react'
import { colors } from '../../../constants/colors';
import { faEdit, faEye, faTrash } from '@fortawesome/free-solid-svg-icons';
import TableRowCommon from '../../../component/table/TableRowCommon';
import HeaderCard from '../../../component/cardCustom/headerCard';
import StallsListApi from '../../../api/stalls-list/stalls-list.api';
import { getBranch, handleTypingNumber } from '../../../utils/app.utils';
import { useTranslation } from 'react-i18next';
import { useHistory, useParams } from 'react-router-dom';
import InputTextField from '../../../component/input/inputTextField';
import TableCustom from '../../../component/table/tableCustom';
import ButtonCustom from '../../../component/button/buttonCustom';
import AutocompleteSelect from '../../../component/select/autoCompleteSelect';
import ZoneApi from '../../../api/zone/zone.api';
import StallTypeApi from '../../../api/setting/stall/stall.api';
import { useDispatch } from 'react-redux';
import { notiError, notiSuccess } from '../../../component/notification/notifications';
import { closeModal, showModal } from '../../../app/slice/modal.slice';
import ModalCustom from '../../../component/modalCustom/modalCustom';
import FilterSelect from '../../../component/select/filterSelect';
import _ from 'lodash';
import AddBoxIcon from '@mui/icons-material/AddBox';
import IndeterminateCheckBoxIcon from '@mui/icons-material/IndeterminateCheckBox';
import QrCodeIcon from '@mui/icons-material/QrCode';
import PopupDowloadQr from '../market-map/popup/popupDowloadQr';
import { swalActive, swalDelete } from '../../../component/notification/swal';
import { renderStatus, stall_status } from './enum/enum';
export default function StallManage() {
  const { t } = useTranslation();
  const history = useHistory();
  const { id } = useParams<any>();

  const [page, setPage] = useState<number>(1)
  const [pageLimit, setPageLimit] = useState<number>(25)
  const [search, setSearch] = useState<string>("");
  const [stallTypeId, setStallTypeId] = useState<string>("ALL");
  const [status_stalls_data, set_status_stalls_data] = useState<string>("ทั้งหมด");
  const [status_stalls, set_status_stalls] = useState<string>("ALL");
  const [type, setType] = useState<string>("");
  const [rowCount, setRowCount] = useState<number>();
  const [zoneData, setZoneData] = useState<any[]>([]);
  const [stallType, setStallType] = useState<any[]>([]);

  const branchId: number = Number(getBranch() || 1);
  const [dataZone, setDataZone] = useState<any | any>({});
  const [dataStall, setDataStall] = useState<any>({});
  const [zoneId, setZoneId] = useState<number>();
  // const [stallId, setStallId] = useState<number>();
  const [zoneOption, setZoneOption] = useState<any[]>([]);
  const [stallOption, setStallOption] = useState<any[]>([]);
  const dispatch = useDispatch();
  const [popupQrCode, setPopupQrCode] = useState<boolean>(false);
  const [qrCode, setQrCode] = useState<any>();

  const [form, setForm] = useState<any>({
    meters: [{ meterNumber: '', meterType: 'WATER' }, { meterNumber: '', meterType: 'ELECTRICITY' },]
  })
  const [errorMessage, setErrorMessage] = useState<any>();
  const clearErrorMessage = () => setErrorMessage({});

  const loadStallType = useCallback(async () => {
    const condition: any = {
      page: 1,
      pageLimit: 50,
      sortBy: "modifiedDate",
      sortType: "ASC",
      status: "ACTIVE",
    };

    const res = await StallTypeApi.findAll(condition);
    if (res.status === 200) {
      setStallType(res.data);
    }
  }, []);

  useEffect(() => {
    loadStallType();
  }, [loadStallType]);

  const loadDataStall = useCallback(async () => {
    let condition: any = {
      page: page,
      limit: pageLimit,
      keyword: search || "",
      branchId,
      zoneId: id,
    }
    if (search) condition = { ...condition, keyword: search }
    if (stallTypeId && stallTypeId !== 'ALL') condition = { ...condition, stallTypeId: stallTypeId }
    if (status_stalls_data && status_stalls_data !== 'ทั้งหมด') condition = { ...condition, status_stalls_data: status_stalls_data }
    if (status_stalls && status_stalls  !== 'ALL') condition = { ...condition, status: status_stalls }


    const res = await StallsListApi.stallsList(condition)

    if (res.status === 200) {
      setZoneData(res.data.data.items)
      setRowCount(res.data.data.meta?.totalItems)

    } else {
      setZoneData([])
    }
  }, [page, pageLimit, search, stallTypeId, status_stalls_data, status_stalls])

  useEffect(() => {
    loadDataStall()
  }, [loadDataStall])

  const getDetail = async (id: any) => {
    const res = await StallsListApi.findById(id)

    if (res.status === 200) {
      setForm({ ...res.data.data, meters: res.data.data?.meterNumber })

    } else {
      setForm(null)
    }
  }
  const getQR = async (id: any, stallId: any) => {
    const res = await StallsListApi.qr(id, stallId)

    if (res.status === 200) {
      setPopupQrCode(true)
      setQrCode(res.data.data)
      // setForm({ ...res.data.data, meters: res.data.data?.meterNumber })

    } else {
      setQrCode(null)
    }
  }
  const deleteStall = async (id: any) => {
    const res = await StallsListApi.delete(id)

    if (res.status === 200) {
      loadDataStall()
    } else {

    }
  }
  const headCells = [
    { id: "no", disablePadding: false, label: 'ชื่อโซน' },
    { id: "date", disablePadding: false, align: 'center', label: t("เลขแผงค้า") },
    { id: "zoneName", disablePadding: false, align: 'center', label: t("ชื่อแผงค้า") },
    { id: "stall", disablePadding: false, align: 'center', label: t("ประเภทแผงค้า") },
    { id: "stall", disablePadding: false, align: 'center', label: t("สถานะข้อมูล") },
    { id: "stallType", disablePadding: false, align: 'center', label: t("สถานะแผงค้า") },
    { id: "action", disablePadding: false, align: 'center', label: t("") },
  ];

  const renderData = (objData: any, no: any) => {
    no = page * pageLimit - pageLimit + no + 1

    const { zoneId, zoneName, stallName, stallNumber, stallTypeNameTh
      , status_stalls_data, status, stallId } =
      objData;

    const objRenderData = {
      key: zoneId,
      id: zoneId,
      obj: objData,
      columns: [
        { option: "TEXT", align: "left", label: zoneName },
        { option: "TEXT", align: "center", label: stallNumber || "-" },
        { option: "TEXT", align: "center", label: stallName || "-" },
        { option: "TEXT", align: "center", label: stallTypeNameTh || "-" },
        { option: "TEXT", align: "center", label: status_stalls_data || "-" },
        { option: "TEXT", align: "center", label: renderStatus(status) || "-" },
        {
          option: "COMPONENT",
          align: "center",
          component: (
            <div className="d-flex align-items-center justify-content-center mx-auto w-100">

              <Tooltip title="ดู">
                <IconButton onClick={() => {
                  dispatch(showModal());
                  getDetail(stallId)
                  setType('VIEW')
                }}>
                  <FontAwesomeIcon
                    icon={faEye}
                    style={{
                      fontSize: "20px",
                      width: "22px",
                      color: colors.themeMainColor
                    }}
                  />
                </IconButton>
              </Tooltip>
              <Tooltip title="แก้ไข">
                <IconButton onClick={() => {
                  dispatch(showModal());
                  getDetail(stallId)
                  setType('EDIT')

                }}>
                  <FontAwesomeIcon
                    icon={faEdit}
                    style={{
                      fontSize: "20px",
                      width: "22px",
                      color: colors.themeMainColor
                    }}
                  />
                </IconButton>
              </Tooltip>
              <Tooltip title="ลบ">
                <IconButton onClick={() => {
                  // swalDelete('ต้องการจะลบหรือไม่', undefined, () => deleteStall(stallId))
                  swalActive(
                    'ต้องการจะลบหรือไม่ ?', '',
                    (status: any) => {
                      if (status) {
                        deleteStall(stallId)
                      } else {
                        return;
                      }
                    },
                    'info',)

                }}>
                  <FontAwesomeIcon
                    icon={faTrash}
                    style={{
                      fontSize: "20px",
                      width: "22px",
                      color: colors.themeMainColor
                    }}
                  />
                </IconButton>
              </Tooltip>

            </div>
          ),
        },


      ],
    };
    return (<TableRowCommon {...objRenderData} />
    )
  };
  const handleSubmit = async () => {
    const body = {
      ...form,
      branchId: branchId,
      zoneId: +id,
      realWidth: +form?.realWidth,
      realHeight: +form?.realHeight,
      meters: form?.meters?.filter((item: any) => item.meterNumber)
    }
    if (!form?.stallName)
      return setErrorMessage({
        ...errorMessage,
        ...{ stallName: 'ระบุชื่อแผง' },
      });
    if (!form?.stallNumber)
      return setErrorMessage({
        ...errorMessage,
        ...{ stallNumber: 'ระบุเลขแผง' },
      });
    if (!form?.stallTypeId)
      return setErrorMessage({
        ...errorMessage,
        ...{ stallTypeId: 'ระบุประเภทแผง' },
      });
    if (!form?.realWidth)
      return setErrorMessage({
        ...errorMessage,
        ...{ realWidth: 'ระบุชื่อความกว้าง' },
      });
    if (!form?.realHeight)
      return setErrorMessage({
        ...errorMessage,
        ...{ realHeight: 'ระบุชื่อความยาว' },
      });

    if (form?.stallId) {
      const res = await StallsListApi.update(form?.stallId, body)
        .then(res => {
          if (res.status === 200) {
            notiSuccess(t('บันทึกแผงสำเร็จ'))
            dispatch(closeModal())
          }
        })
        .catch(() => {
          notiError('ไม่สามารถบันทึกได้')
        })
        .finally(() => loadDataStall())
    } else {
      const res = await StallsListApi.create(body)
        .then(res => {
          if (res.status === 200) {
            notiSuccess(t('บันทึกแผงสำเร็จ'))
            dispatch(closeModal())
          }
        })
        .catch(() => {
          notiError('ไม่สามารถบันทึกได้')
        })
        .finally(() => loadDataStall())
    }


  }
  const handleMeterNumberChange = (originalIndex: number, value: string) => {
    const updatedMeters = [...form.meters];
    updatedMeters[originalIndex].meterNumber = value;
    setForm({ ...form, meters: updatedMeters });
  };
  return (
    <>
      <HeaderCard text={t("รายการแผงค้า")} />
      <Box sx={{
        padding: "24px 48px",
        height: '100vh',
      }}>
        <Box>
          <Grid container spacing={2}>
            <Grid item lg={3} md={6} xs={12}>
              <InputTextField heading="ค้นหา" value={search}
                onchange={(e: any) => setSearch(e.target.value)} />
            </Grid>
            <Grid item lg={3} md={6} xs={12}>

              <FilterSelect
                onchange={(event) => {
                  const value = event.target.value;
                  setStallTypeId(value)
                  // clearErrorMessage()
                }}
                renderValue={() =>
                  `${_.find(
                    [{ stallTypeNameTh: 'ทั้งหมด', stallTypeId: 'ALL' }, ...stallType],
                    (p: any) => p.stallTypeId === stallTypeId
                  )?.stallTypeNameTh
                  }`
                }
                heading="ประเภทแผงค้า"
                selectId="select-stallType"
                labelId="label-stallType"
                value={stallTypeId}
                options={[
                  _.map([{ stallTypeNameTh: 'ทั้งหมด', stallTypeId: 'ALL' }, ...stallType], (props: any, i: number) => (
                    <MenuItem key={i} value={props.stallTypeId}>
                      {props.stallTypeNameTh}
                    </MenuItem>
                  )),
                ]}

              />
            </Grid>
            <Grid item lg={3} md={6} xs={12}>
              <FilterSelect
                onchange={(event) => {
                  const value = event.target.value;
                  set_status_stalls_data(value)
                  // clearErrorMessage()
                }}
                renderValue={() =>
                  `${_.find(
                    ['ทั้งหมด','ข้อมูลครบถ้วน', 'ข้อมูลไม่ครบถ้วน'],
                    (p: any) => p === status_stalls_data
                  )
                  }`
                }
                heading="สถานะข้อมูล"
                selectId="select-stallType"
                labelId="label-stallType"
                value={status_stalls_data}
                options={[
                  _.map(['ทั้งหมด', 'ข้อมูลครบถ้วน', 'ข้อมูลไม่ครบถ้วน'], (props: any, i: number) => (
                    <MenuItem key={i} value={props}>
                      {props}
                    </MenuItem>
                  )),
                ]}

              />
            </Grid>
            <Grid item lg={2} md={6} xs={12}>
              <FilterSelect
                onchange={(event) => {
                  const value = event.target.value;
                  set_status_stalls(value)
                  // clearErrorMessage()
                }}
                renderValue={() =>
                  `${_.find(
                    [{ label: 'ทั้งหมด', value: 'ALL' }, ...stall_status],
                    (p: any) => p?.value === status_stalls
                  )?.label
                  }`
                }
                heading="สถานะแผงค้า"
                selectId="select-stallType"
                labelId="label-stallType"

                value={status_stalls}
                options={[
                  _.map([{ label: 'ทั้งหมด', value: 'ALL' }, ...stall_status], (props: any, i: number) => (
                    <MenuItem key={i} value={props?.value}>
                      {props?.label}
                    </MenuItem>
                  )),
                ]}

              />
            </Grid>
            <Grid item lg={1} md={6} xs={12}>
              <div style={{ display: 'flex', justifyContent: 'end', alignItems: 'end', height: "100%" }}>

                <ButtonCustom
                  type="submit"
                  textButton={'เพิ่ม'}
                  onClick={() => {
                    dispatch(showModal());
                    setForm({
                      meters: [{ meterNumber: '', meterType: 'WATER' }, { meterNumber: '', meterType: 'ELECTRICITY' },]
                    })
                    setType('ADD')

                  }}
                  style={{ margin: '0px' }}
                  btnStyle={{
                    fontSize: "16px",
                    width: "100%",
                    padding: "0px",
                    margin: '0px'
                  }}
                />
              </div>
            </Grid>

          </Grid>
        </Box>
        <Box sx={{ marginTop: '24px', }}>
          <TableCustom
            headCells={headCells}
            customScroll={true}
            page={page}
            pageLimit={pageLimit}
            sortType={"ASC"}
            sortBy=""
            rowCount={rowCount}
            rowsData={zoneData.map((d: any, i: any) => {
              return renderData(d, i);
            })}
            onSort={() => { }}
            setPageLimit={(value: number) => setPageLimit(value)}
            setPage={(value: number) => setPage(value)}
            tableMinWidth={1024}
          />
        </Box>
      </Box>
      <ModalCustom
        title={
          'รายละเอียดเพิ่มแผงค้า'
        }
        size="xl"
        onSubmit={type !== 'VIEW' ? () => {
          handleSubmit()
        } : undefined}
        closeButton
        textBtnCancel={
          'ยกเลิก'
        }
        textBtnConfirm={
          'บันทึก'
        }
        component={
          <>
            <Grid container spacing={2}>

              <Grid item xs={12} className="w-100">
                <InputTextField
                  key="name"
                  value={form?.stallName}
                  onchange={(e) => {
                    setForm({ ...form, stallName: e.target.value })
                    clearErrorMessage()
                  }}
                  required={true}
                  helperText={errorMessage?.stallName || ''}
                  heading={t("ชื่อแผงค้า")}
                  disabled={type === 'VIEW'}
                />
              </Grid>
              <Grid item md={6} xs={12} className="w-100">
                <InputTextField
                  key="name"
                  value={form?.stallNumber}
                  onchange={(e) => {
                    setForm({ ...form, stallNumber: e.target.value })
                    clearErrorMessage()
                  }}
                  required={true}
                  helperText={errorMessage?.stallNumber || ''}
                  heading={t("เลขแผงค้า")}
                  // onkeypress={handleTypingNumber}
                  disabled={type === 'VIEW'}

                />
              </Grid>
              <Grid item md={6} xs={12} className="w-100">
                <FilterSelect
                  onchange={(event) => {
                    const value = event.target.value;
                    setForm({ ...form, stallTypeId: value })
                    clearErrorMessage()
                  }}
                  renderValue={() =>
                    `${_.find(
                      stallType,
                      (p: any) => p.stallTypeId === form?.stallTypeId
                    )?.stallTypeNameTh
                    }`
                  }
                  heading="ประเภท"
                  selectId="select-stallType"
                  labelId="label-stallType"
                  value={form?.stallTypeId}
                  options={[
                    _.map(stallType, (props: any, i: number) => (
                      <MenuItem key={i} value={props.stallTypeId}>
                        {props.stallTypeNameTh}
                      </MenuItem>
                    )),
                  ]}
                  disabled={type === 'VIEW'}

                />
              </Grid>
              <Grid item xs={12} className="w-100">
                <Typography sx={{ fontSize: "24px", fontWeight: '600', color: colors.themeMainColor }}>ขนาดแผงค้า</Typography>
              </Grid>
              <Grid item md={6} xs={12} className="w-100">
                <InputTextField
                  key="name"
                  value={form?.realWidth}
                  onchange={(e) => {
                    setForm({ ...form, realWidth: e.target.value })
                    clearErrorMessage()
                  }}
                  required={true}
                  helperText={errorMessage?.realWidth || ''}
                  heading={t("ความกว้าง (เมตร)")}
                  onkeypress={handleTypingNumber}
                  disabled={type === 'VIEW'}

                />
              </Grid>
              <Grid item md={6} xs={12} className="w-100">
                <InputTextField
                  key="name"
                  value={form?.realHeight}
                  onchange={(e) => {
                    setForm({ ...form, realHeight: e.target.value })
                    clearErrorMessage()
                  }}
                  required={true}
                  helperText={errorMessage?.realHeight || ''}
                  heading={t("ความยาว (เมตร)")}
                  onkeypress={handleTypingNumber}
                  disabled={type === 'VIEW'}

                />
              </Grid>
              <Grid item xs={12} className="w-100">
                <Typography sx={{ fontSize: "24px", fontWeight: '600', color: colors.themeMainColor }}>ประเภทการใช้น้ำ : ตามมิเตอร์</Typography>
              </Grid>
              <Grid item xs={12} className="w-100">
                <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
                  {form?.meters
                    ?.map((item: any, i: number) => ({ ...item, originalIndex: i })) // ใส่ index ไว้ก่อน
                    ?.filter((item: any) => item.meterType === 'WATER')
                    ?.map((item: any, index: number) => {
                      return (
                        <div style={{ display: 'flex', alignItems: "end", gap: '10px' }}>
                          <div style={{ width: "100%" }}>
                            <InputTextField
                              key="name"
                              value={item?.meterNumber || ''}
                              onchange={(e) => handleMeterNumberChange(item.originalIndex, e.target.value)}
                              required={true}
                              // helperText={errorMessage?.realHeight || ''}
                              heading={t("เลขมิเตอร์")}
                              onkeypress={handleTypingNumber}
                              disabled={type === 'VIEW'}

                            />
                          </div>
                          {type !== 'VIEW' && index === 0 && <Tooltip title="เพิ่ม">
                            <IconButton onClick={() => { setForm({ ...form, meters: [...form?.meters, { meterNumber: '', meterType: 'WATER' },] }) }}>
                              <AddBoxIcon sx={{ color: colors?.themeMainColor }} />
                            </IconButton>
                          </Tooltip>}
                          {type !== 'VIEW' && index !== 0 && <Tooltip title="ลบ">
                            <IconButton onClick={() => { setForm({ ...form, meters: [...form?.meters?.filter((x: any) => x?.meterType === 'ELECTRICITY'), ...form?.meters?.filter((x: any) => x?.meterType === 'WATER')?.filter((x: any, i: number) => i !== index),] }) }}>
                              <IndeterminateCheckBoxIcon sx={{ color: colors?.red }} />
                            </IconButton>
                          </Tooltip>}
                          {item?.stallId && <Tooltip title="QR code">
                            <IconButton onClick={() => { getQR(item?.meterId, item?.stallId) }}>
                              <QrCodeIcon sx={{ color: colors?.themeMainColor }} />
                            </IconButton>
                          </Tooltip>}
                        </div>
                      )
                    })}
                </div>
              </Grid>
              <Grid item xs={12} className="w-100">
                <Typography sx={{ fontSize: "24px", fontWeight: '600', color: colors.themeMainColor }}>ประเภทการใช้ไฟฟ้า : ตามมิเตอร์</Typography>
              </Grid>
              <Grid item xs={12} className="w-100">
                <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
                  {form?.meters?.map((item: any, i: number) => ({ ...item, originalIndex: i }))?.filter((item: any) => item?.meterType === 'ELECTRICITY')?.map((item: any, index: number) => {
                    return (
                      <div style={{ display: 'flex', alignItems: "end", gap: '10px' }}>
                        <div style={{ width: "100%" }}>
                          <InputTextField
                            key="name"
                            value={item?.meterNumber || ''}
                            onchange={(e) => handleMeterNumberChange(item.originalIndex, e.target.value)}
                            required={true}
                            // helperText={errorMessage?.realHeight || ''}
                            heading={t("เลขมิเตอร์")}
                            onkeypress={handleTypingNumber}
                            disabled={type === 'VIEW'}

                          />
                        </div>
                        {type !== 'VIEW' && index === 0 && <Tooltip title="เพิ่ม">
                          <IconButton onClick={() => { setForm({ ...form, meters: [...form?.meters, { meterNumber: '', meterType: 'ELECTRICITY' },] }) }}>
                            <AddBoxIcon sx={{ color: colors?.themeMainColor }} />
                          </IconButton>
                        </Tooltip>}
                        {type !== 'VIEW' && index !== 0 && <Tooltip title="ลบ">
                          <IconButton onClick={() => { setForm({ ...form, meters: [...form?.meters?.filter((x: any) => x?.meterType === 'ELECTRICITY')?.filter((x: any, i: number) => i !== index), ...form?.meters?.filter((x: any) => x?.meterType === 'WATER')] }) }}>
                            <IndeterminateCheckBoxIcon sx={{ color: colors?.red }} />
                          </IconButton>
                        </Tooltip>}
                        {item?.stallId && <Tooltip title="QR code">
                          <IconButton onClick={() => { getQR(item?.meterId, item?.stallId) }}>
                            <QrCodeIcon sx={{ color: colors?.themeMainColor }} />
                          </IconButton>
                        </Tooltip>}
                      </div>
                    )
                  })}
                </div>
              </Grid>
            </Grid>
            {popupQrCode && (
              <PopupDowloadQr
                data={form}
                zone={form?.zone}
                qrcode={qrCode?.qrcode}
                isShow={popupQrCode}
                setIsShow={(show: boolean) => setPopupQrCode(show)}
                type={qrCode?.meterType}
              />
            )}
          </>
        }
      />
    </>
  )
}
